<app-page-meta pageTitle="FAQs about P2P lending, investments, easy online loans in India - finzy"
               tags="lending, p2p lending india, p2p lending, p2p lender, how lending works, Borrowing, p2P loans, easy loans online, personal loans, how borrowing works, p2p borrower"
               description="Resolve your queries about peer to peer lending in India. Read Finzy’s FAQs about P2P loans, P2P lending, easy loans online, quick personal loans, low interest personal loans and investment opportunities.">
</app-page-meta>

<app-header>
</app-header>
<p class="faq-headertext">Frequently Asked Questions</p>

<div class="row faq-maindiv">

    <ul class="nav nav-pills">
        <li [class.active]="selectedTab == Tabs.BORROWER"><a data-toggle="tab" href="#1b">Borrower</a></li>
        <li [class.active]="selectedTab == Tabs.INVESTOR"><a data-toggle="tab" href="#2b">Investor</a></li>
        <li [class.active]="selectedTab == Tabs.FINZY_FLEX"><a data-toggle="tab" href="#8b">finzyFLEX</a></li>
        <li [class.active]="selectedTab == Tabs.FINZY_PRO"><a data-toggle="tab" href="#3b">finzyPRO+</a></li>
        <li [class.active]="selectedTab == Tabs.FINZY_BOLT"><a data-toggle="tab" href="#7b">finzyBolt</a></li>
        <li [class.active]="selectedTab == Tabs.REINVEST"><a data-toggle="tab" href="#6b">Reinvest-Pro</a></li>
        <li [class.active]="selectedTab == Tabs.PRICING"><a data-toggle="tab" href="#4b">Pricing</a></li>
        <li [class.active]="selectedTab == Tabs.REFERRAL"><a data-toggle="tab" href="#5b">Refer & Earn</a></li>
    </ul>

    <div class="tab-content clearfix">

        <div [class.active]="selectedTab == Tabs.BORROWER" class="tab-pane" id="1b">

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        1. Can I borrow through finzy?
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">You can borrow through finzy if you:</p>
                <ul class="font">
                    <li>Are an Indian national with identity proof and address proof</li>
                    <li>Are at least 18 years old</li>
                    <li>Have take home salary of more than Rs 25000 or an annual business income of at least 5 lakhs per
                        annum
                    </li>
                </ul>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        2. What is the process for getting a loan through finzy?
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">A finzy loan can be acquired in 3 simple steps:</p>
                <ol type=1>
                    <li>Submit your loan application on finzy in as little as 5 minutes. You would need your PAN card,
                        proof of
                        your residential address, recent photograph and income documents.
                    </li>
                    <li>Team finzy will analyze your application and give you a loan decision within 1 business day,
                        subject to all documents being in order. We
                        will
                        indicate to you
                        the loan amount and rate of interest that you would need to pay.
                    </li>
                    <li>Upon your acceptance of loan terms, your requirement would be listed on finzy. Only approved
                        Investors
                        will be able to see your requirement. Typically, your requirement would get funded from
                        Investors in a few
                        minutes to a few hours. We will complete the loan document signature process thereon and
                        directly fund your
                        bank account.
                    </li>
                </ol>

            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        3. What documents do I need to give at the time of their registration?
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">We would require soft copies of the below documents if you are a salaried
                    individual</p>

                <ul>
                    <li>Pan card</li>
                    <li>Current address proof (see Question 4)</li>
                    <li>3 months salary slip as on date</li>
                    <li>3 months bank statement as on date</li>
                    <li>Previous year ITR/Form 16</li>
                    <li>Recent photograph</li>
                </ul>

                <p class="faq-acc-content">If you are self-employed then soft copies of the below documents are
                    required</p>

                <ul>
                    <li>Pan card</li>
                    <li>Current address proof (see Question 4)</li>
                    <li>6 Months bank statement as on date</li>
                    <li>Previous two years ITR</li>
                    <li>Recent photograph</li>
                    <li>6 months current account statement (only if savings account does not contain income details)
                    </li>
                    <li>Government provided business proof (only if a current account statement is being submitted)</li>
                </ul>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        4. What documents can I submit for my current address proof?
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">You can submit any of the following documents as your current address
                    proof:</p>

                <ul>
                    <li>Masked e-Aadhaar</li>
                    <li>Driving License</li>
                    <li>Passport</li>
                    <li>Voter ID</li>
                    <li>Electricity bill (< 3 months old)</li>
                    <li>LPG bill (< 3 months old)</li>
                    <li>BSNL/MTNL landline bill (< 3 months old)</li>
                </ul>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        5. Can I submit physical copy of these documents?
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">
                    finzy strives to reduce the turnaround time in funding your loan requirement. As part of that
                    attempt, we need
                    only soft/digital copies of your documents at the time of registration.
                </p>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        6. What amount can I borrow and at what rate of interest?
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">
                    We offer loans from &#8377; 25,000 to &#8377; 5,00,000 for tenures of 6, 12, 24 or 36 months.
                    Your credit rating will determine the rate of interest you will pay on your finzy loan and possible
                    tenures that you can avail. The rate of
                    interests
                    at finzy start at 10.99% and go up to 27.99%.</p>
                <p class="faq-acc-content">Interest rates varies across borrowers based on their individual credit
                    assessment
                    derived from our proprietary and scientific Finzy Credit Algorithm.</p>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        7. What are the tenures available with finzy?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">
                    We offer 36 months as the default tenure, this reduces your monthly EMI and gives you more
                    flexibility
                    with your
                    monthly cash-flow. However, you may also choose a tenure of 6, 12, or 24 months. Your credit
                    assessment will determine the tenure you can avail. If you have applied for a loan through finzy’s
                    partners, you might be
                    eligible to get a loan at a
                    non-standard tenure.
                </p>
                <p class="faq-acc-content">
                    In any case, you have the flexibility to partly or fully prepay without incurring any early
                    prepayment penalty. Please note that you can prepay on any day of the month except between 1st and
                    10th of the
                    month.
                </p>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        8. What are the registration fees at finzy?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">
                    finzy does not charge registration fees. A loan processing fee is charged at the time of disbursal
                    of your
                    loan. The fee is a percentage of the amount disbursed and may vary based on your finzy Rating:</p>

                <div class="faqtable">
                    <table class="table finzy-datatable table-responsive">
                        <thead>
                        <tr>
                            <th>Category</th>
                            <th>Finzy Rating</th>
                            <th>% of disbursal amount charged as fee</th>
                        </tr>
                        </thead>

                        <tbody>


                        <tr>
                            <td class="faqtr" rowspan=6>A</td>
                            <td>A1</td>
                            <td>2.00%</td>
                        </tr>

                        <tr>
                            <td>A2</td>
                            <td>2.00%</td>
                        </tr>

                        <tr>
                            <td>A3</td>
                            <td>2.00%</td>
                        </tr>

                        <tr>
                            <td>A4</td>
                            <td>3.00%</td>
                        </tr>

                        <tr>
                            <td>A5</td>
                            <td>3.00%</td>
                        </tr>

                        <tr>
                            <td>A6</td>
                            <td>3.00%</td>
                        </tr>

                        <tr>
                            <td class="faqtr" rowspan=6>B</td>
                            <td>B1</td>
                            <td>4.00%</td>
                        </tr>


                        <tr>
                            <td>B2</td>
                            <td>4.00%</td>
                        </tr>

                        <tr>
                            <td>B3</td>
                            <td>4.00%</td>
                        </tr>

                        <tr>
                            <td>B4</td>
                            <td>4.00%</td>
                        </tr>

                        <tr>
                            <td>B5</td>
                            <td>4.00%</td>
                        </tr>

                        <tr>
                            <td>B6</td>
                            <td>4.00%</td>
                        </tr>

                        <tr>
                            <td class="faqtr" rowspan=6>C</td>
                            <td>C1</td>
                            <td>4.50%</td>
                        </tr>

                        <tr>
                            <td>C2</td>
                            <td>4.50%</td>
                        </tr>

                        <tr>
                            <td>C3</td>
                            <td>4.50%</td>
                        </tr>

                        <tr>
                            <td>C4</td>
                            <td>5.00%</td>
                        </tr>

                        <tr>
                            <td>C5</td>
                            <td>5.00%</td>
                        </tr>

                        <tr>
                            <td>C6</td>
                            <td>5.00%</td>
                        </tr>

                        </tbody>
                    </table>
                    <p class="tablefooter">Note: GST of 18% on the processing fee will be additionally levied.</p>
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        9. What is the Credit Assessment Process at finzy?
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">
                    The Objective of the credit assessment process is to assess borrowers on a wide range of parameters
                    using our
                    proprietary and scientific Finzy Credit Algorithm to ensure Right Borrowers are verified and loans
                    are
                    sanctioned.
                </p>
                <p class="step-header faq-acc-content">Basic Qualifying Criteria</p>
                <ul class="left-spaced">
                    <li>Applicant should 18 years of age or above</li>
                    <li>Should be an Indian National with valid address and ID proof</li>
                    <li>Should have a steady Income (Rs 35000 or more in case Salaried or an annual business income of
                        at least 5
                        lakhs in case Self-Employed)
                    </li>
                </ul>

                <p class="step-header faq-acc-content">Step 1: KYC Re-validation</p>
                <p class="faq-acc-content">At this stage the documents which has cleared the KYC stage and moved for
                    Preliminary
                    Credit Decision stage are re-validated.</p>

                <p class="step-header faq-acc-content">Step 2: Detailed Credit Decision Stage</p>
                <p class="faq-acc-content">This stage involves a detailed analysis on the below parameters</p>
                <ul class="left-spaced">
                    <li>Demographic Information</li>
                    <li>Income and Employment Details</li>
                    <li>Savings and Investment Patterns</li>
                    <li>Analysis of committed and Voluntary Expenses</li>
                    <li>Leverage Ratios</li>
                    <li>Past repayment track record</li>
                    <li>Analysis of utilisation of credit lines</li>
                    <li>Social Media Activity</li>
                    <li>Field verification and Database checks</li>
                </ul>
                <p class="faq-acc-content">Basis the above analysis the final rating is populated by the proprietary
                    finzy
                    credit algorithm which
                    decides the loan amount and Rate of interest.</p>

                <p class="step-header faq-acc-content">Step 3: Customer Communication and Sanction</p>
                <p class="faq-acc-content">Customers are out-called and communicated on the Loan offer followed by a
                    Sanction
                    letter to the registered Email ID which has complete information on the Loan amount, Approximate
                    monthly EMI,
                    processing fees and GST charges. The loan gets listed on the platform once the same is accepted.</p>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        10. What is a credit score?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">A credit score is typically a number from 300-900 which is an indicator of an
                    individuals “probability to repay”. This is calculated largely based on historical loan repayment
                    track
                    record.
                </p>
                <p class="faq-acc-content">
                    A score of 750 and above is considered a good score. and people with a good credit score tend to get
                    approved
                    faster for loans and get a better interest rate.
                </p>
                <p class="faq-acc-content">
                    If you have a low credit score, it is probably because you may have delayed credit card repayments
                    (even one
                    or two defaulted payments can affect your score), or missed a loan payment. A low credit score
                    doesn't mean
                    that you can’t apply for a loan, but the interest rates on the loans offered can have harsher terms
                    and higher
                    interest rates.
                </p>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        11. Do you conduct credit history checks?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">As per our policy we would conduct a credit history check. While most of the
                    banks
                    and
                    NBFCs in India tend to focus on credit score as the most important parameter in their credit
                    underwriting
                    process, we at finzy have worked out a credit algorithm which takes into account your historical
                    repayment
                    track record and not the credit score.</p>
                <p class="faq-acc-content">We lend sizable weightage to several other parameters to assign a finzy score
                    to your
                    credit application. Hence we offer proliferation of credit by serving both served and under-served
                    customers.</p>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        12. Do credit history checks with credit bureaus impact my credit score?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">No. At finzy we do a soft check and this does not impact your credit
                    score.</p>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        13. Does finzy use CIBIL Report for checking credit history?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">CIBIL (TransUnion CIBIL) is not the only company that provides a credit
                    score. There
                    are
                    three other large credit bureaus that evaluate your ‘credit-worthiness’, namely Equifax, Experian
                    and High Mark.</p>

                <p class="faq-acc-content">finzy uses the Equifax, CRIF and CIBIL report to analyse the credit history.</p>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        14. What is finzy Rating and how is it calculated?
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">
                    finzy uses scientific approach to analyze repayment capacity of every Borrower. We study multiple
                    factors of
                    each Borrower across income details, amount of existing commitments and leverage, past loan
                    repayment track
                    record and several other related parameters. Based on these inputs, we arrive at finzy Rating using
                    our
                    proprietary credit algorithm and linked to each level of rating is a rate of interest. finzy Rating
                    ranges
                    from A1 to C6, with A1 being most credit worthy and C6 being riskiest credit rating.
                </p>


            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        15. Is my identity revealed on listing to Investors?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">
                    Your contact details, your address or your photograph is not revealed to investors at the listing
                    stage.
                    However, RBI requires us to share your name and certain demographic information to the investor
                    during the
                    listing stage.
                </p>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        16. Who is funding my loan?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">Your loan requirement is funded only by registered Investors. Minimum 5
                    (five)
                    investors would be investing in your requirement. finzy takes care of all the documentation,
                    collection and
                    co-ordination activities. For you, finzy remains the point of contact for any requirement with
                    respect to your
                    loan.</p>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        17. How is Interest Calculated?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">
                    Interest calculations are on reducing balance basis. Interest is applicable only on the outstanding
                    amount.
                </p>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        18. How is EMI collected?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">
                    Every month an EMI amount would be debited from your account electronically. You just need to ensure
                    that
                    adequate funds are maintained in your bank account.
                </p>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        19. Can I choose my EMI repayment date?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">
                    No. The EMI date is fixed and the same would be debited from your bank account on the 5th of every
                    month.
                </p>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        20. What happens if I miss a payment?
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">Any delay or default of EMI would impact your capacity to borrow in
                    future.</p>
                <p class="faq-acc-content">We would levy penal charges and delayed payment fees as follows:</p>
                <p class="faq-acc-content">finzy fee component (variable that keeps changing every 30 days) + Penal charges component 
                    (Variable that changes based on the outstanding principal amount and the number of days of delay)</p>

                <div class="faqtable">
                    <table class="table finzy-datatable table-responsive">
                        <thead>
                        <tr>
                            <th>Principal Outstanding</th>
                            <th>Penal Charges</th>
                            <th class="text-center">finzy Fees</th>
                        </tr>
                        </thead>

                        <tbody>
                        <tr>
                            <td>1 - 50000</td>
                            <td>&#8377; 15 per day of delay</td>
                            <td class="center-in-column" rowspan="6">
                                6 to 30 days: &#8377; 500<br>31 to 60 days: &#8377; 1000<br>
                                61 to 90 days: &#8377; 1500<br>91 days and beyond: &#8377; 2000<br>
                            </td>
                        </tr>

                        <tr>
                            <td>50,001 - 1,50,000</td>
                            <td>&#8377; 30 per day of delay</td>
                        </tr>

                        <tr>
                            <td>1,50,001 - 2,50,000</td>
                            <td>&#8377; 60 per day of delay</td>
                        </tr>

                        <tr>
                            <td>2,50,001 - 3,50,000</td>
                            <td>&#8377; 90 per day of delay</td>
                        </tr>

                        <tr>
                            <td>3,50,001 - 4,50,000</td>
                            <td>&#8377; 120 per day of delay</td>
                        </tr>

                        <tr>
                            <td>4,50,001 - 5,00,000</td>
                            <td>&#8377; 150 per day of delay</td>
                        </tr>

                        </tbody>
                    </table>
                </div>
                <p class="faq-acc-content">
                    For example, a person with a loan amount of &#8377; 2,00,000 whose EMI is overdue by 40 days will
                    have to pay
                    a finzy fee of &#8377; 1000 and a penal fee of &#8377; 2400 (60*40) along with his regular EMI.
                </p>
                <p class="faq-acc-content">
                    We have tie ups with bank recognized collection agencies across the country, in case of continued
                    default,
                    these agencies would approach you for collecting the outstanding principal, interest and penal
                    charges. You
                    may also have to face the consequences of legal proceedings and your details might be reported to
                    credit
                    information companies and various defaulter databases.
                </p>

            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        21. Can I make an early repayment?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">Yes, you can repay your loan early without incurring any early repayment
                    penalty. You
                    can either choose to foreclose the loan by repaying the entire outstanding amount or reduce the EMI
                    by
                    prepaying a part of the outstanding amount. Part prepayment shall be in multiple of Rs 1,000/- with
                    a minimum
                    of Rs 5,000/-. In order to prepay your loan, please write an email to
                    <a href="mailto:support@finzy.com" target="_blank">support@finzy.com</a>.
                    Please note that you can prepay on any day of the month except between 1st and 10th of the month.
                </p>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        22. How much time does it take for a loan to be listed?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">Once a borrower registers and uploads the required documents the credit
                    assessment
                    team takes about 24 working hours to evaluate the borrower and provide the decision on the amount of
                    loan and
                    Rate of interest. Once the borrower accepts the offer the same is listed on our platform which will
                    be
                    invested by multiple verified investors.</p>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        23. When will my loan be disbursed and what are the documents required?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">Once a loan is listed and filled by investors a representative from Finzy
                    would visit
                    you to complete the documentation.The borrower will have to sign a tripartite Loan Agreement form,
                    Demand
                    Promisory Note, NACH Mandate and provide 3 undated cheques in the name of Bridge Fintech Solutions
                    Pvt Ltd. On
                    receipt of these documents the loan will be disbursed from the Lender Escrow account to the borrower
                    savings
                    account.
                </p>
                <p class="faq-acc-content">The amount will be disbursed after deducting the processing fees and GST
                    charges.</p>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        24. What documents would need my signature before disbursal of loan?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">Our representative will collect following documents before disbursement of
                    loan:</p>
                <ul class="font">
                    <li>Loan Agreement</li>
                    <li>3 (Three) post dated cheques (PDCs)</li>
                    <li>Demand Promissory Note</li>
                    <li>National Automated Clearing House (NACH) registration mandate</li>
                </ul>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        25. Why do I need give Post Dated Cheques to finzy?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">
                    Post dated cheques are used in the event your electronic EMI mandate is not setup properly or we
                    need to
                    recover loan amounts which have been outstanding and overdue. These cheques are in name of Bridge
                    Fintech
                    Solutions Private Limited, parent company of finzy. Do not worry, we at finzy ensure that your
                    cheques are not
                    misused in any way.
                </p>

            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        26. How do I transfer or cancel my NACH mandate?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">
                    If you wish to cancel your NACH mandate or transfer it to a different bank account, please get in
                    touch with us at <a href="mailto:support@finzy.com">support@finzy.com</a> or call us on 9341 300
                    300.
                </p>

            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        27. What is the Multiple loans feature ?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">
                    Multiple loans is an exclusive feature for our customers who have maintained an excellent borrowing
                    track record on finzy.
                    This feature allows our customers to access loans from finzy multiple times while their current
                    loan and its terms remain unchanged.
                </p>

            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        28. What are the benefits of the Multiple loans feature ?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <ul>
                    <li>Flexibility & Power: to access Loans from finzy multiple times while your current loan and its
                        terms remain unchanged
                    </li>
                    <li>Better terms : As a reward for your track record, you can get loans at your earlier or probably
                        even better interest rates
                    </li>
                    <li>Easy access : As a privileged Customer, you get your loans processed faster with updated
                        documents
                    </li>
                    <li>The entire process of documentation is now 100% digital, giving you the convenience to access
                        loans with our zero physical contact initiative
                    </li>
                </ul>

            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        29. What set of customers is the Multiple loans feature exclusively available to ?
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">
                    Multiple personal loans are available to our privileged customers who have:
                </p>
                <ol>
                    <li>Remained responsible in paying their EMIs on time</li>
                    <li>Prepaid and closed their loans</li>
                    <li>Paid and completed the loan tenure</li>
                    <li>Had a finzy loan sanctioned in the past but chose not to avail the loan for various reasons</li>
                </ol>

            </mat-expansion-panel>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        30. What would be the terms of the new loan ?
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">
                    We strive to keep the terms of the new loan either at par with or better than the old/current loan
                    with Finzy.
                    Terms of new loan will be a result of your:
                </p>
                <ul>
                    <li>Track record with finzy</li>
                    <li>Current income and leverage status</li>
                    <li>Track record with other financial institutions</li>
                </ul>

            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        31. Will I need to submit all my documents once again when applying for a new loan ?
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">
                    We have some of your information already in our records. We would request you to revalidate some of
                    this and resubmit your address proof and income documents to help us offer you the best loan terms
                </p>

            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        32. What is the maximum amount that I can expect from Finzy ?
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">
                    At this point, we limit the cumulative loan amount (including your existing loan) to Rs 5 lacs from
                    finzy. As we move ahead, we intend to extend this limit to Rs 10 lacs which happens to be the
                    regulatory limit from RBI
                </p>

            </mat-expansion-panel>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        33. Are the loans secured?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">finzy offers collateral free loans. In the event of continued default,
                    documents
                    collected above serve as security to initiate criminal proceedings under Indian legal system.</p>

            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        34. Why has my Loan Application been rejected?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">finzy reserves the right to decline a loan application in case of
                    insufficient credit
                    worthiness. As per our credit verification process, incomplete documentation in accordance with
                    finzy policy,
                    unsuccessful document verification, submission of incorrect information deliberately to cheat the
                    finzy
                    systems and processes, are reasons to decline loan applications.</p>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        35. Can a borrower be an investor as well?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">Yes. If you have registered as a borrower on finzy, then you can also
                    register as an
                    investor, irrespective of what stage your loan application is in. However, you will not be allowed
                    to invest
                    in your own loan.
                </p>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        36. How is Bridge Fintech Solutions Private Limited connected with finzy?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">The domain name www.finzy.com and brand name finzy, is owned and operated by
                    Bridge
                    Fintech Solutions Private Limited, a private limited company incorporated under the Companies Act,
                    2013 with
                    its registered office at, L&T Crescent Bay, T-5, 2002, Jerbai Wadi Road, Parel, Mumbai 400 012,
                    Maharashtra,
                    India.</p>
            </mat-expansion-panel>

        </div>

        <div [class.active]="selectedTab == Tabs.INVESTOR" class="tab-pane" id="2b">

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        1. Can I invest in a finzy loan?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">You can invest through finzy if you:</p>
                <ul>
                    <li>You’re a tax paying Indian resident with identity proof and address proof</li>
                    <li>If an individual, are at least 18 years old</li>
                    <li>You have annual income is more than &#8377; 3 Lakhs or networth is more than &#8377; 10 Lakhs
                    </li>
                </ul>
            </mat-expansion-panel>


            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        2. Who can be a borrower through finzy?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">A borrower needs to be:</p>
                <ul class="font">
                    <li>Indian national with identity proof and address proof</li>
                    <li>at least 18 years old</li>
                    <li>earning take home salary of more than Rs 25000 or an annual business income of at least 5 lakhs
                        per
                        annum.
                    </li>
                </ul>
            </mat-expansion-panel>


            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        3. What is the process for investing in a finzy loan?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">You can invest in a finzy loan in 4 simple steps:</p>
                <ol type=1>
                    <li>Register yourself as an Investor on finzy in as little as 5 minutes. You would need your PAN
                        card, proof
                        of your residential address and recent photograph
                    </li>
                    <li>Team finzy will quickly verify your KYC and approve your registration as an investor.</li>
                    <li>You need to set up your pre-investment wallet at finzy by transferring the amount you wish to
                        invest.
                    </li>
                    <li>You will get access to listing of loan requirements of borrowers. You can choose to screen
                        individual
                        loans and invest manually or you can invest at a click through our auto Invest option.
                    </li>
                </ol>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        4. How do I transfer money to my investment wallet?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">You can transfer money to your finzy wallet via the unique Virtual Account
                    Number assigned to to your finzy investment account. Your Virtual Account details are available on
                    your dashboard. </p>
                <p class="faq-acc-content">To add money to your wallet - Add the Virtual Account Details as a
                    beneficiary in your bank account and make a transfer. Once you make a successful transfer, the
                    amount will start reflecting in your wallet. You will also receive an email confirmation. </p>

                <div class="faq-acc-content">
                    If you hold an <b>ICICI Bank Account</b>, please follow the below steps -
                    <ol>
                        <li>While adding a new payee, select “<b>ICICI Bank Virtual Payee</b>” to add finzy Virtual
                            Account ID
                            as a beneficiary.
                            <ul>
                                <li>Payee Account Name is "Bridge Fintech Solutions Pvt Ltd"</li>
                                <li>Payee Account Number is your unique Virtual Account ID displayed on the dashboard
                                </li>
                            </ul>
                        </li>
                        <li>
                            Make a transfer to the Virtual Account.
                        </li>
                        <li>
                            Once you make a successful transfer and the amount is credited, it will start reflecting in
                            your wallet.
                        </li>
                    </ol>
                </div>

                <div class="faq-acc-content">
                    Note:
                    <ol>
                        <li><b> Virtual Account ID is specific to a PAN number and finzy investment wallet. Money
                            transferred to
                            a Virtual Account ID will reflect in the wallet linked to the respective PAN.
                        </b></li>
                        <li>
                            Some banks might not allow adding Virtual Account IDs as a new beneficiary on their mobile
                            app.
                            In such a case, you might have to login using the web version of the bank to add the
                            beneficiary.
                        </li>
                    </ol>
                </div>

            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        5. What is a Virtual Account?
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">A virtual account is a unique account number created and assigned to each
                    lender.
                    This is done in order to differentiate each lender’s payments. The Virtual Account in turn is linked
                    to the
                    lender escrow account.<b> Please note that a Virtual Account ID is specific to a PAN number and
                        finzy
                        investment
                        account. </b>
                </p>

            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        6. How much can I Invest and for how long?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">We have a minimum threshold of ₹ 50000 only for your first investment, after
                    which
                    you can top-up your wallet and create portfolios with a minimum size of ₹ 5000 in multiples of ₹
                    1000. Each of
                    your investments will have standard tenure of 36 months. In some cases, there might be some loans
                    available with
                    a non standard tenure. Tenure of each loan can be viewed in the borrower details. Based on the RBI
                    master
                    directions, there is an upper limit of ₹ 50 Lakhs that can be invested across all P2P lending
                    platforms.</p>

            </mat-expansion-panel>


            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        7. What is Manual Invest and finzyPro+?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">
                    Manual Invest allows you to review details of all available loans and choose the precise amount of
                    investment in each loan to create your own portfolio.
                </p>
                <p class="faq-acc-content">
                    finzyPro+ adopts a predefined logic to allocate your fund across Multiple loans. It tries to build a
                    balanced portfolio of loans without taking excessive risk. All fund allotments are finalised for
                    investment only after investor approval.
                </p>
                <p class="faq-acc-content">
                    We also allow for a combination of manual and finzyPro+ within portfolios, called Hybrid Invest.
                </p>
            </mat-expansion-panel>


            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        8. What happens if there are not enough loans on the platform to select manually?
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">
                    Our manual invest capability allows you to hand-pick loans that are listed on the platform. 
                    However in case there are not enough loans to match your investment amount you can pick the loans that you like and choose to invest the remaining portion of the money via the finzyQ. 
                    Every time a new loan is listed on the platform, finzyQ will check if this loan is suited for you. Our proprietary algorithm <strong>will pick loans to allocate without you visiting our platform</strong>.
                </p>
                <p class="faq-acc-content">Since you would have manually selected one or more loans already in your portfolio, the algorithm takes into account the following criteria when selecting a loan for you:</p>
                <ol style="font-size: 15px;">
                    <li>Ensures that the loan is not very high-risk - So the algorithm will not pick any loans that belong to the C Category.</li>
                    <li>Ensures diversification – For portfolios above ₹ 10,000, it will invest only 20% of the loan amount or 10% of the total portfolio or the amount remaining to be funded in the loan, whichever is lower.</li>
                    <li>Ensures that you do not invest in the same loan more than once.</li>
                    <li>Ensures that the total investment in a single loan is not more than lowest of the three:
                        <ul>
                            <li>Dynamic cap amount which varies based on portfolio amount and finzy Rating of the loan</li>
                            <li>Maximum amount as determined by 10% of the portfolio amount or 20% of the loan amount, whichever is lower</li>
                            <li>₹ 50,000</li>
                        </ul>
                </ol>
                <p class="faq-acc-content">If the loan matches the criteria, it will allot the portion of amount as an investment.</p>
                <p class="faq-acc-content font-weight-bold">
                    You will receive an email confirming the allocation along with the details of the loan and the borrower. 
                    You will have a choice to remove the allocation from this specific loan by sending an email to finzy or by simply reversing it from your dashboard within a stipulated time, 
                    we will remove the allocation and find a replacement loan for you. 
                    If you accept the allocated loan, you are all set and need not take any action.
                </p>
            </mat-expansion-panel>



            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        9. What is finzy Rating and how is it calculated?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">
                    finzy uses scientific approach to analyze repayment capacity of every Borrower. We study multiple
                    factors of
                    each borrower across income details, amount of existing commitments and leverage, past loan
                    repayment track
                    record, employment details and several other related parameters. Based on these inputs, we arrive at
                    finzy
                    Rating using our proprietary credit algorithm. Linked to each level of rating is a rate of interest.
                    finzy
                    Rating ranges from A1 to C6, with A1 being most credit worthy and C6 being riskiest credit rating.
                </p>
            </mat-expansion-panel>


            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        10. Can I invest in a single loan through finzy?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">
                    We take care of your money by ensuring that your investment is split across Multiple loans. You need
                    to have
                    minimum of 5 loans in your investment portfolio. Higher the number of loans in a portfolio, lower
                    the credit
                    risk.
                </p>
            </mat-expansion-panel>


            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        11. Can I invest in the same loan or borrower more than once ?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">
                    To safeguard you from excessive exposure on any one loan, we restrict investment in one loan only
                    once.
                </p>
                <p class="faq-acc-content">
                    If a borrower has an excellent repayment track record on finzy, they would have the option of
                    applying
                    for a new loan on finzy. This would be in addition to the loan they already have on finzy.
                </p>
                <p class="faq-acc-content">
                    An investor would be allowed to invest in this new loan that is listed on the platform,
                    however finzy ensures that your total investment in a borrower does not exceed the RBI specified
                    limit of INR 50,000.
                </p>
            </mat-expansion-panel>


            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        12. Who carries the risk of default in an invested loan?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">Credit risk of investment lies with investor. finzy helps you understand and
                    manage
                    the risk by assigning appropriate finzy Rating to every loan and ensuring diversification of your
                    investment.</p>
            </mat-expansion-panel>


            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        13. Does finzy guarantee any rate of return or return of investment?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">
                    finzy is a digital marketplace to connect investors and borrowers. We do not guarantee any rate of
                    return or
                    return of investment amount. We provide information for you to understand the risk and all returns
                    are purely
                    based on your investment decisions.
                </p>
            </mat-expansion-panel>


            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        14. What are the registration fees and charges at finzy?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">finzy does not charge registration fees or any fees at the time of
                    investment. We
                    levy a nominal 2% fees plus GST for the amount of funds collected from borrowers. So we earn a small
                    fees, only when you make money.<br/><br/>
                </p>
            </mat-expansion-panel>


            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        15. How is the Investor ROI calculated at finzy?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">
                    Investor ROI (Return on Investment) is calculated using Internal Rate of Return (IRR) method at
                    Finzy. Internal Rate of Return
                    (IRR) is a measure of an investment’s rate of return. This takes into account the timing and quantum
                    of cash inflow and outflow
                    such as to make the Net Present Value (NPV) of cash flow 0. Investor ROI displayed to investors is
                    the net IRR which is post finzy
                    fee of 2% of EMI Amount earned + 18% of GST on finzy fee.
                </p>
            </mat-expansion-panel>


            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        16. What affects investor ROI?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">
                    Investor ROI is a function of two primary parameters:
                </p>
                <ol>
                    <li><b>Rate of Interest of a loan:</b> This is based on the Finzy Rating of loans, riskier loan
                        exposures are compensated by
                        higher
                        interest
                        rate.
                    </li>
                    <li>
                        <b>Periodicity of Interest Payment:</b> Loans with frequent payment frequencies will have higher
                        IRR. At annual interest
                        frequency Rate of Interest of a loan is the same as IRR, whereas IRR is much higher for a loan
                        with monthly interest
                        periodicity. At Finzy, we have monthly periodicity of payments.<br/>

                        For example:<br/>
                        <table class="table finzy-datatable table-responsive">
                            <thead>
                            <tr>
                                <th>Description</th>
                                <th>ROI</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>Rate of Interest</td>
                                <td>15.99%</td>
                            </tr>
                            <tr>
                                <td>IRR at annual interest payment frequency</td>
                                <td>15.99%</td>
                            </tr>
                            <tr>
                                <td>IRR at monthly interest payment frequency (for Finzy Loans)</td>
                                <td>17.22%</td>
                            </tr>
                            <tr>
                                <td>Net IRR post finzy fee of 2% of EMI Amount earned + 18% of GST on finzy fee) at
                                    monthly interest payment
                                    frequency
                                </td>
                                <td>14.51%</td>
                            </tr>
                            </tbody>
                        </table>
                        Net IRR is also influenced by original tenure of the loan and prepayments, if any.

                    </li>
                </ol>

            </mat-expansion-panel>


            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        17. Why is the Rate of Interest of a loan different from Investor ROI?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">
                    At Finzy, Rate of Interest of a loan will always different from Investor ROI, because of:
                </p>
                <ul>
                    <li>Monthly periodicity of EMI of Finzy Loans</li>
                    <li>Investor ROI displayed is net IRR i.e. IRR less finzy fee of 2% of EMI Amount earned + 18% of
                        GST on finzy fee.
                    </li>
                </ul>
                <p>Below is depiction of how rate of interest of a loan is different from Net IRR, Standard 36 months
                    tenure
                </p>

                <table class="table finzy-datatable table-responsive">
                    <thead>
                    <tr>
                        <th>Rate of Interest of a loan</th>
                        <th>IRR</th>
                        <th>Investor ROI (Net IRR)</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>10.99%</td>
                        <td>11.56%</td>
                        <td>8.98%</td>
                    </tr>
                    <tr>
                        <td>11.99%</td>
                        <td>12.67%</td>
                        <td>10.07%</td>
                    </tr>
                    <tr>
                        <td>12.99%</td>
                        <td>13.79%</td>
                        <td>11.16%</td>
                    </tr>
                    <tr>
                        <td>13.99%</td>
                        <td>14.92%</td>
                        <td>12.27%</td>
                    </tr>
                    <tr>
                        <td>14.99%</td>
                        <td>16.06%</td>
                        <td>13.39%</td>
                    </tr>
                    <tr>
                        <td>15.99%</td>
                        <td>17.22%</td>
                        <td>14.51%</td>
                    </tr>
                    <tr>
                        <td>16.99%</td>
                        <td>18.38%</td>
                        <td>15.65%</td>
                    </tr>
                    <tr>
                        <td>17.99%</td>
                        <td>19.55%</td>
                        <td>16.80%</td>
                    </tr>
                    <tr>
                        <td>18.99%</td>
                        <td>20.73%</td>
                        <td>17.96%</td>
                    </tr>
                    <tr>
                        <td>19.99%</td>
                        <td>21.93%</td>
                        <td>19.13%</td>
                    </tr>
                    <tr>
                        <td>20.99%</td>
                        <td>23.13%</td>
                        <td>20.31%</td>
                    </tr>
                    <tr>
                        <td>21.99%</td>
                        <td>24.35%</td>
                        <td>21.50%</td>
                    </tr>
                    </tbody>
                </table>
                <p>*Numbers would vary depending on the disbursement date</p>
            </mat-expansion-panel>


            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        18. Why do I see a change in the ROI between portfolio creation and funds disbursal?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">
                    You might see a difference in Investor ROI from the time of portfolio creation to disbursal of loan
                    because of difference in
                    assumed and actual disbursal date.
                </p>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        19. What documents are collected from Borrowers at the time of their registration?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">
                    Borrowers provide following documents for us to assign finzy Rating to the loan</p>
                <ul class="font">
                    <li>Complete KYC document including your most recent photograph</li>
                    <li>Demographic Information</li>
                    <li>Bank Account Statement</li>
                    <li>Salary Slips</li>
                    <li>Income Tax Return or Form 16</li>
                </ul>
                <p class="faq-acc-content">
                    In addition of above, we also take a report on entire repayment history of a Borrower from Equifax
                    Credit
                    Information Services Private Limited, a registered Credit Information Company.</p>
            </mat-expansion-panel>


            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        20. What documents are collected from Borrowers before the disbursement of loan?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">
                    Borrowers provide following documents before disbursement of loan:</p>
                <ul class="font">
                    <li>Loan Agreement</li>
                    <li>3 (Three) post dated cheques (PDCs)</li>
                    <li>Demand Promissory Note</li>
                    <li>National Automated Clearing House (NACH) registration mandate</li>
                </ul>
            </mat-expansion-panel>


            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        21. What kind of information I would see to form an opinion on borrower?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">You would see following details to assess credit risk of borrower:</p>
                <ul class="font">
                    <li>Amount of Loan</li>
                    <li>finzy Rating</li>
                    <li>finzy Score</li>
                    <li>Gender</li>
                    <li>Age</li>
                    <li>Marital Status</li>
                    <li>Educational Qualification</li>
                    <li>City of Residence</li>
                    <li>Employment Sector</li>
                    <li>Number of years of experience</li>
                    <li>Net Monthly Salary/Annual Income</li>
                    <li>Existing Loans</li>
                    <li>Existing EMI</li>
                </ul>
            </mat-expansion-panel>


            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        22. Is borrower’s identity revealed on listing to Investors?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">Borrower’s identity or borrower’s photograph is not revealed to any investor
                    at the
                    listing stage. </p>
            </mat-expansion-panel>


            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        23. Is investor’s identity revealed to the borrowers?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">Borrower’s do not have an option to select their investors. Matching of
                    borrower and
                    investor is anonymous process.</p>
            </mat-expansion-panel>


            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        24. If I invest in 20 loans, will I see 20 EMI credits in my account every month?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">We take care of collection and reconciliation. You will receive one
                    consolidated
                    electronic entry in your bank account on EMI date for regular payments. Loan level details will be
                    updated in
                    Investor dashboard.</p>
            </mat-expansion-panel>


            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        25. How does finzy decide on order for EMI distribution amongst investors?
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">All investors in a loan are treated equally. Any EMI or principal repayment
                    received
                    from borrower is distributed only on basis of proportion of investment in that loan.</p>
            </mat-expansion-panel>


            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        26. Can I get my investment back at anytime?
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">Investments are repaid on monthly EMIs and investors cannot ask for
                    prepayment from
                    any borrower.</p>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        27. Why am I not able to create any new portfolios?
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">Please check if your finzyBolt preference is ON.
                    You will not be able to create any portfolios from the investor dashboard when you have opted for
                    finzyBolt.
                    If you wish to transfer funds and create portfolios yourself,
                    you can switch off finzyBolt anytime from your preferences <a href="https://finzy.com/preferences"
                                                                                  target="_blank">here</a>
                    and then transfer funds.</p>
            </mat-expansion-panel>


            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        28. What will happen if the loan is prepaid by the borrower?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">On part or full prepayment of a loan by a Borrower, the funds will be divided
                    and
                    repaid to the investors on basis of proportion of investment in that loan.</p>
            </mat-expansion-panel>


            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        29. Is my money invested as soon as I commit funds?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">Funds are disbursed to borrower only after execution of loan documents. Your
                    funds
                    start earning interest after disbursal of loan.</p>
            </mat-expansion-panel>


            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        30. Can I withdraw my commitment?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">Commitment to invest in a loan cannot be withdrawn or cancelled.</p>
            </mat-expansion-panel>


            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        31. Can I transfer money to another account from my finzy wallet?
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">You would have the flexibility of transferring balance uncommitted funds in
                    your
                    wallet back to your own registered account only.</p>
            </mat-expansion-panel>


            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        32. Who controls the funds in the wallet and EMI collections from borrowers?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">finzy has appointed a large scheduled commercial bank as Escrow Bank with
                    transaction
                    access only to a SEBI registered trusteeship company. finzy doesn’t keep any control of investor’s
                    money to
                    itself.</p>
            </mat-expansion-panel>


            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        33. How do I monitor performance of loans and portfolio?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">We provide you detailed overview of loan level and portfolio level
                    information in
                    your online dashboard. You can also monitor the EMI receipts and also give your consent to loan
                    agreements
                    online from different tabs on your dashboard.</p>
            </mat-expansion-panel>


            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        34. When do I get returns of my investments?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">You start earning monthly returns in form of EMI from the very first month
                    of your investment. EMIs get credited into borrower escrow account between 5th and 10th of every
                    month. We transfer your consolidated EMI on 11th of the month. If 11th falls on a bank holiday,
                    EMI amount is credited on next working day. For EMIs collected on and after 11th of the month,
                    EMIs are credited to your account on next working day. Please note that neither you nor finzy earns
                    any interest for overnight balance maintained in borrower escrow account.</p>
            </mat-expansion-panel>


            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        35. Do I have to pay tax on the money I earn by investing?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">All interest amounts earned through the investments at finzy are subject to
                    income
                    tax as per the prevailing regulations.</p>
            </mat-expansion-panel>


            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        36. What happens in case a borrower defaults?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">Any delay or default of EMI would impact the borrower's capacity to borrow in
                    future.</p>
                <p class="faq-acc-content">We would levy penal charges and delayed payment fees as follows:</p>
                <p class="faq-acc-content">finzy fee component (variable that keeps changing every 30 days) + Penal charges component 
                    (Variable that changes based on the outstanding principal amount and the number of days of delay)</p>

                <div class="faqtable">
                    <table class="table finzy-datatable table-responsive">
                        <thead>
                        <tr>
                            <th>Principal Outstanding</th>
                            <th>Penal Charges</th>
                            <th class="text-center">finzy Fees</th>
                        </tr>
                        </thead>

                        <tbody>
                        <tr>
                            <td>1 - 50000</td>
                            <td>&#8377; 15 per day of delay</td>
                            <td class="center-in-column" rowspan="6">
                                6 to 30 days: &#8377; 500<br>31 to 60 days: &#8377; 1000<br>
                                61 to 90 days: &#8377; 1500<br>91 days and beyond: &#8377; 2000<br>
                            </td>
                        </tr>

                        <tr>
                            <td>50,001 - 1,50,000</td>
                            <td>&#8377; 30 per day of delay</td>
                        </tr>

                        <tr>
                            <td>1,50,001 - 2,50,000</td>
                            <td>&#8377; 60 per day of delay</td>
                        </tr>

                        <tr>
                            <td>2,50,001 - 3,50,000</td>
                            <td>&#8377; 90 per day of delay</td>
                        </tr>

                        <tr>
                            <td>3,50,001 - 4,50,000</td>
                            <td>&#8377; 120 per day of delay</td>
                        </tr>

                        <tr>
                            <td>4,50,001 - 5,00,000</td>
                            <td>&#8377; 150 per day of delay</td>
                        </tr>

                        </tbody>
                    </table>
                </div>
                <p class="faq-acc-content">
                    For example, a person with a loan amount of &#8377; 2,00,000 whose EMI is overdue by 40 days will
                    have to pay
                    a finzy fee of &#8377; 1000 and a penal fee of &#8377; 2400 (60*40) along with his regular EMI.
                </p>
                <p class="faq-acc-content">
                    We have tie ups with bank recognized collection agencies across the country, in case of continued
                    default,
                    these agencies would approach the borrower for collecting the outstanding principal, interest and
                    penal
                    charges. The borrower
                    may also have to face the consequences of legal proceedings and their details might be reported to
                    credit
                    information companies and various defaulter databases.
                </p>
                <p class="faq-acc-content">
                    The collections agencies charge fees as a percentage of collection amount. This percentage differs
                    from case
                    to case depending on the time and effort taken. We would proportionately transfer the entire
                    collected amount
                    net of collection agent fees to all the lenders.
                </p>
            </mat-expansion-panel>


            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        37. Can an investor be a borrower as well?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">Yes. If you have registered as an investor on finzy, then you can also
                    register as a borrower irrespective of
                    the status of your investments. However, you will not be allowed to invest in your own loan.</p>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        38. Can a Company Invest in Borrowers through finzy platform?
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content"> Yes, a private Company can become an Investor on finzy platform.
                    The Company official completing the registration on finzy needs to fill in the details of the
                    company along with the required documents.</p>
                <p class="faq-acc-content"> Documents required to complete KYC for an organization: </p>
                <h5>PART-A</h5>
                <ol>
                    <li>MOA + AOA of Company (Memorandum of Association & Article of Association)</li>
                    <li>COI of Company (Company of Incorporation)</li>
                    <li>PAN of Company</li>
                    <li>Address Proof in the name of Company</li>
                    <li>Board Resolution for authorized signatory on the letterhead
                        (format can be provided by our support team)
                    </li>
                </ol>
                <h5>PART-B</h5>
                <p class="faq-acc-content">KYC for the authorized signatory:</p>
                <ol>
                    <li>PAN of authorized signatory</li>
                    <li>Aadhaar of authorized signatory</li>
                    <li>Recent Photo of authorized signatory</li>
                </ol>
                <p class="faq-acc-content">For any assistance please get in touch with us at 9341300300 or
                    <a href="mailto:support@finzy.com">support@finzy.com</a>.</p>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        39. Can I nominate a beneficiary for my investment?
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content"> Yes, individual investors can surely register a beneficiary. Simply fill in
                    the nomination form during registration or you can change nominee details from your dashboard by
                    clicking <a href="/nominee">here</a>.</p>
            </mat-expansion-panel>


            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        40. Can an NRI invest in loans on finzy?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">You can invest in finzy if you are an Indian resident holding a PAN card and
                    valid address proof document issued by Government of India. Your annual income should be more than ₹
                    3 lakhs or net-worth more than ₹ 10 lakhs to invest in finzy. At present, regulations in India do
                    not facilitate non-residents to invest through P2P lending platforms in India. You may, however,
                    experience finzy through one of your family or friends resident in India.</p>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        41. I invested in finzy as a resident in India, however my residency status has now changed to a
                        non-resident?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">Since present regulations in India do not facilitate non-residents to invest
                    through P2P lending platforms in India, we would request you not to invest any further amounts
                    through your finzy account till you become resident Indian again. Your current EMIs would continue
                    to be credited to your registered bank account.</p>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        42. Do I need to take any steps in case my residency status has changed to non-resident?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">In such an event, we would request you not to invest any further amounts
                    through your finzy account. Also, we request you to update your Reinvestment Pro preferences to not
                    to reinvest any part of EMI and prepayments. Same would be credited to your registered bank
                    account.</p>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        43. How is Bridge Fintech Solutions Private Limited connected with finzy?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">The domain name www.finzy.com and brand name finzy, is owned and operated by
                    Bridge
                    Fintech Solutions Private Limited, a private limited company incorporated under the Companies Act,
                    2013 with
                    its registered office at, L&T Crescent Bay, T-5, 2002, Jerbai Wadi Road, Parel, Mumbai 400 012,
                    Maharashtra,
                    India.
                </p>
            </mat-expansion-panel>

        </div>

        <div [class.active]="selectedTab == Tabs.FINZY_PRO" class="tab-pane" id="3b">


            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        1. What is finzyPRO+?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">
                    <strong>finzyPRO+ is our scientific algorithm to allocate your funds in loans wihtout you visiting our platform.</strong>
                    <br/><br/>
                    It allows you to further diversify your investments granularly across loans. 
                    This proprietary logic also balances the risk and returns in line with your your custom risk preferences.
                    <br/><br/>
                    finzyPRO+ portfolios can be created at a click of a button within 3 seconds. We take care of your money by ensuring that your investment is split across Multiple loans.
                </p>
            </mat-expansion-panel>


            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        2. What are the advantages of finzyPRO+?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">finzyPRO+ offers following distinct advantages:</p>
                <ul class="font">
                    <li>Quick and easy – create your portfolio in less than 3 seconds</li>
                    <li>Diversified portfolio – we ensure that your investment is split across loans</li>
                    <li>Optimised risk – our finzyPRO+ algorithm selects the loan to offer you optimized balance of risk
                        and
                        return
                    </li>
                    <li>You get benefits of finzyQ</li>
                    <ul class="font">
                        <li>Get access to best loans as soon as they are listed</li>
                        <li>Your money works harder and faster</li>
                        <li>Do not need to login multiple times to manually select loans</li>
                    </ul>
                </ul>
            </mat-expansion-panel>


            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        3. How does finzyPRO+ work?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content font-weight-bold">finzyPRO+ is our proprietary logic to allocate loans without you visiting our platform. It takes into account the following when selecting loans:</p>

                <ol style="font-size: 15px;">
                    <li>Ensures that the loan is not very high-risk - So the algorithm will not pick any loans that belong to the C Category.</li>

                    <li>Ensures diversification – For portfolios above ₹ 10,000, it will invest only 20% of the loan amount or 10% of the total portfolio or the amount remaining to be funded in the loan, whichever is lower.</li>

                    <li>Ensures that you do not invest in the same loan more than once.</li>

                    <li>Ensures that the total investment in a single loan is not more than lowest of the three:
                        <ul>
                            <li>Dynamic cap amount which varies based on portfolio amount and finzy Rating of the loan</li>
                            <li>Maximum amount as determined by 10% of the portfolio amount or 20% of the loan amount, whichever is lower</li>
                            <li>₹ 50,000</li>
                        </ul>
                    </li>
                </ol>

                <p class="faq-acc-content">Once finzyPRO+ finds the loans that suit you, we display these loans to you so that you can review them.</p>

                <p class="faq-acc-content">If finzyPRO+ does not find enough loans to match your portfolio amount, you may choose to invest the remaining money through finzyQ.</p>

                <p class="faq-acc-content">
                    Every time a new loan is listed on the platform, finzyQ will check if this loan is suited for you by applying the same logic as listed above. 
                    If the loan is suited, it will allot the portion of amount.
                </p>

                <p class="faq-acc-content font-weight-bold">
                    You will receive an email confirming the allocation along with the details of the loan and the borrower. 
                    You will have a choice to remove the allocation from this specific loan by sending an email to finzy or by simply reversing it from your dashboard within a stipulated time, we will remove the allocation and find a replacement loan for you. 
                    If you accept the allocated loan, you are all set and need not take any action.
                </p>

            </mat-expansion-panel>


            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        4. Can I select loans in finzyPRO+?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">
                    finzyPRO+ is designed to select best loans in your portfolio. You can however choose the loan rating
                    categories that you would want finzyBolt to invest in by setting the “finzyPRO+ Master Rating
                    Preference”<br/><br/>

                    You can also use finzy Manual Invest to create your own portfolio using your own assessment and
                    judgement.
                </p>
            </mat-expansion-panel>


            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        5. How do I set my loan rating preference for finzyPRO+ portfolios?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">
                    By default, your master rating preference will be used to show you loans while creating a finzyPRO+
                    portfolio. However, you can change the rating preference to customise each finzyPRO+ portfolio in
                    line with your risk appetite.<br/><br/>

                    Changing your preference while creating a finzyPRO+ portfolio will find loans only in the selected
                    rating categories. This preference will only be applicable to the individual portfolio and each
                    finzyPRO+ portfolio can have a different rating preference.
                </p>
            </mat-expansion-panel>


            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        6. What returns can I expect in finzyPRO+?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">finzyPRO+ offers return ranging from 10.99% per annum to 21.99% per annum
                    depending
                    upon availability of loans across finzy Ratings.</p>
            </mat-expansion-panel>


            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        7. Can I select my own return, risk grade or investment preference?
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">We will soon launch a feature whereby you would be able to invest across
                    finzy
                    designed portfolios and also customize your own portfolio.</p>
            </mat-expansion-panel>


            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        8. How do I transfer funds to my finzy Wallet?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">Before you begin investing you would need to transfer funds to Lender Escrow
                    Account
                    (details available in finzy wallet tab on your dashboard) and notify finzy at support@finzy.com with
                    following
                    details.</p>
                <br>
                <p class="faq-acc-content">Your PAN number, Amount transferred, Transfer Date, Transfer mode: RTGS,
                    NEFT, IMPS
                    or Cheque, Electronic transfer reference number or cheque number.</p>
            </mat-expansion-panel>


            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        9. What is the minimum and maximum amount that I can invest using finzyPRO+?
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">For your first investment, you will need a minimum of INR 50,000 in your
                    finzy wallet to invest using finzyPRO+. After this initial investment, you will need a minimum
                    wallet
                    balance of INR 5,000 to use finzyPRO+. Reinvest-Pro returns are exempt from this; all funds in
                    reinvested portfolios are automatically allocated using finzyPRO+. There is no upper limit for
                    investments, aside from the RBI imposed INR 50 lakhs cap for investment across all P2P
                    platforms.</p>
            </mat-expansion-panel>


            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        10. What is finzyQ?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">In case we are unable to invest all your money online through finzyPRO+. We
                    keep good
                    to our promise to select right loans and park your requirement in finzyQ. Here we invest in the
                    right loans as
                    and when they get listed.</p>
            </mat-expansion-panel>


            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        11. How do I know that my funds have been invested?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">We keep you informed at every stage of investment cycle. We will send SMS and
                    email
                    notifications to you at every stage. We will send consolidated day end SMS and email to you for
                    funds invested
                    in a day. You can also log into your dashboard at www.finzy.com to check the status of
                    investment.</p>
            </mat-expansion-panel>


            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        12. Who gets priority in finzyQ?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">finzyQ follows the logic of first in first out (FIFO). So sooner you commit
                    your
                    funds, earlier you stand chance to start earning interest.</p>
            </mat-expansion-panel>


            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        13. When does my money start earning interest?
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">Your funds start earning interest only after successful disbursement of loan.
                    On an
                    average there would be a time lag of 3 to 5 days between you transferring funds to you starting to
                    earn
                    interest on your funds.</p>
            </mat-expansion-panel>


            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        14. Who controls the funds when my investment is waiting in finzyQ?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">finzy has appointed a large scheduled commercial bank as Escrow Bank with
                    transaction
                    access only to a SEBI registered trusteeship company. finzy doesn’t keep any control of investor’s
                    money to
                    itself.</p>
            </mat-expansion-panel>

        </div>

        <div [class.active]="selectedTab == Tabs.PRICING" class="tab-pane" id="4b">
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        1.What are the registration fees at finzy?
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content"><b>
                    <u>For lenders:</u></b>
                    <br/> finzy does not charge registration fees or
                    any fees
                    at the time of investment. We levy a nominal 2% fees plus GST for the amount of funds collected from
                    borrowers. So we earn a small fees, only when you make money.
                    <br/>
                </p>

                <p class="faq-acc-content"><b><u>For borrowers:</u></b><br/> finzy does not charge registration fees. A
                    loan
                    processing fee is charged at the time of disbursal of your loan. The fee is a percentage of the
                    amount
                    disbursed and may vary based on your finzy rating as explained here</p>

                <div class="faqtable">
                    <table class="table finzy-datatable table-responsive">
                        <thead>
                        <tr>
                            <th>Category</th>
                            <th>Finzy Rating</th>
                            <th>% of disbursal amount charged as fee</th>
                        </tr>
                        </thead>

                        <tbody>
                        <!-- <tr>
                            <td class="faqtr" rowspan=3>A+</td>
                            <td>A+1</td>
                            <td>2.00%</td>
                        </tr>
                        <tr>
                            <td>A+2</td>
                            <td>2.00%</td>
                        </tr>
                        <tr>
                            <td>A+3</td>
                            <td>2.00%</td>
                        </tr> -->
                        <tr>
                            <td class="faqtr" rowspan=6>A</td>
                            <td>A1</td>
                            <td>2.00%</td>
                        </tr>

                        <tr>
                            <td>A2</td>
                            <td>2.00%</td>
                        </tr>

                        <tr>
                            <td>A3</td>
                            <td>2.00%</td>
                        </tr>

                        <tr>
                            <td>A4</td>
                            <td>3.00%</td>
                        </tr>

                        <tr>
                            <td>A5</td>
                            <td>3.00%</td>
                        </tr>

                        <tr>
                            <td>A6</td>
                            <td>3.00%</td>
                        </tr>

                        <tr>
                            <td class="faqtr" rowspan=6>B</td>
                            <td>B1</td>
                            <td>4.00%</td>
                        </tr>


                        <tr>
                            <td>B2</td>
                            <td>4.00%</td>
                        </tr>

                        <tr>
                            <td>B3</td>
                            <td>4.00%</td>
                        </tr>

                        <tr>
                            <td>B4</td>
                            <td>4.00%</td>
                        </tr>

                        <tr>
                            <td>B5</td>
                            <td>4.00%</td>
                        </tr>

                        <tr>
                            <td>B6</td>
                            <td>4.00%</td>
                        </tr>

                        <tr>
                            <td class="faqtr" rowspan=6>C</td>
                            <td>C1</td>
                            <td>4.50%</td>
                        </tr>

                        <tr>
                            <td>C2</td>
                            <td>4.50%</td>
                        </tr>

                        <tr>
                            <td>C3</td>
                            <td>4.50%</td>
                        </tr>

                        <tr>
                            <td>C4</td>
                            <td>5.00%</td>
                        </tr>

                        <tr>
                            <td>C5</td>
                            <td>5.00%</td>
                        </tr>

                        <tr>
                            <td>C6</td>
                            <td>5.00%</td>
                        </tr>

                        </tbody>
                    </table>
                    <p class="tablefooter">Note: A GST of 18% on the processing fee will be additionally levied</p>
                </div>
            </mat-expansion-panel>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        2.What happens if I miss a payment?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">Any delay or default of EMI would impact your capacity to borrow in
                    future.</p>
                <p class="faq-acc-content">We would levy penal charges and delayed payment fees as follows:</p>
                <p class="faq-acc-content">finzy fee component (variable that keeps changing every 30 days) + Penal charges component 
                    (Variable that changes based on the outstanding principal amount and the number of days of delay)</p>

                <div class="faqtable">
                    <table class="table finzy-datatable table-responsive">
                        <thead>
                        <tr>
                            <th>Principal Outstanding</th>
                            <th>Penal Charges</th>
                            <th class="text-center">finzy Fees</th>
                        </tr>
                        </thead>

                        <tbody>
                        <tr>
                            <td>1 - 50000</td>
                            <td>&#8377; 15 per day of delay</td>
                            <td class="center-in-column" rowspan="6">
                                6 to 30 days: &#8377; 500<br>31 to 60 days: &#8377; 1000<br>
                                61 to 90 days: &#8377; 1500<br>91 days and beyond: &#8377; 2000<br>
                            </td>
                        </tr>

                        <tr>
                            <td>50,001 - 1,50,000</td>
                            <td>&#8377; 30 per day of delay</td>
                        </tr>

                        <tr>
                            <td>1,50,001 - 2,50,000</td>
                            <td>&#8377; 60 per day of delay</td>
                        </tr>

                        <tr>
                            <td>2,50,001 - 3,50,000</td>
                            <td>&#8377; 90 per day of delay</td>
                        </tr>

                        <tr>
                            <td>3,50,001 - 4,50,000</td>
                            <td>&#8377; 120 per day of delay</td>
                        </tr>

                        <tr>
                            <td>4,50,001 - 5,00,000</td>
                            <td>&#8377; 150 per day of delay</td>
                        </tr>

                        </tbody>
                    </table>
                </div>
                <p class="faq-acc-content">
                    For example, a person with a loan amount of &#8377; 2,00,000 whose EMI is overdue by 40 days will
                    have to pay
                    a finzy fee of &#8377; 1000 and a penal fee of &#8377; 2400 (60*40) along with his regular EMI.
                </p>
                <p class="faq-acc-content">
                    We have tie ups with bank recognized collection agencies across the country, in case of continued
                    default,
                    these agencies would approach you for collecting the outstanding principal, interest and penal
                    charges. You
                    may also have to face the consequences of legal proceedings and your details might be reported to
                    credit
                    information companies and various defaulter databases.
                </p>
            </mat-expansion-panel>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        3. What are the prepayment fees at finzy?
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">
                    finzy does not levy any part/full prepayment fees. Please note that you can prepay on any day of the
                    month
                    except between 1st and 10th of the month (both days inclusive). Part prepayment shall be in multiple
                    of Rs
                    1,000/- with a minimum of Rs 5,000/-.
                </p>
            </mat-expansion-panel>
        </div>

        <div [class.active]="selectedTab == Tabs.REFERRAL" class="tab-pane" id="5b">
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        1. What is the validity of the referral program?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">The referral program is valid from {{raferralDate.dateFrom}} to {{raferralDate.dateTo}}.</p>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        2. Who can I refer to finzy?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">You can refer both investors and borrowers to the platform. There are only 3
                    criteria to consider:</p>
                <ol>
                    <li>They are above 18 years of age.
                    <li>They are Citizens of India.
                    <li>They are not already registered with finzy.
                </ol>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        3. Who is eligible to refer other users on finzy?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">Once you register as an investor or a borrower on finzy
                    you can start referring other users.
                    However if you have been introduced to finzy by a financial advisor / institution,
                    you will not be eligible to refer other user. </p>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        4. How do I get my personal referral code?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">Once you register as an investor or a borrower, you would receive an email
                    and an SMS
                    with your
                    personal referral code. You can also view your referral code on your finzy dashboard in the 'Refer &
                    Earn'
                    section. If you have been introduced to finzy by a financial advisor / institution,
                    you will not receive an email and an SMS with your personal referral code.
                    You will not be able to view your referral code on your finzy dashboard in the 'Refer & Earn'
                    section.</p>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        5. How do I earn referral benefits in the referral program?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">You earn referral benefits only when:</p>
                <ol>
                    <li>Investors you have referred have created their first portfolio on or after {{raferralDate.dateFrom}} and
                        have invested ₹ 1 lakh or more in loans at finzy, or
                    </li>
                    <li>Borrowers you have referred get loan amount greater than &#8377; 1 lakh or more successfully
                        disbursed from finzy.
                    </li>
                </ol>
                <div class="faqtable">
                    <table class="table finzy-datatable table-responsive">
                        <thead style="font-weight: bold">
                        <td>Cumulative Investment Milestones(&#8377;)</td>
                        <td>Referral Earning(&#8377;)</td>
                        <td>Total Referral Earnings(&#8377;)</td>
                        </thead>
                        <tbody>
                        <tr>
                            <td>1,00,000</td>
                            <td>1,000</td>
                            <td>1,000</td>
                        </tr>
                        <tr>
                            <td>5,00,000</td>
                            <td>5,000</td>
                            <td>6,000</td>
                        </tr>
                        <tr>
                            <td>10,00,000</td>
                            <td>7,000</td>
                            <td>13,000</td>
                        </tr>
                        <tr>
                            <td>20,00,000</td>
                            <td>12,000</td>
                            <td>25,000</td>
                        </tr>
                        <tr>
                            <td>30,00,000</td>
                            <td>15,000</td>
                            <td>40,000</td>
                        </tr>
                        <tr>
                            <td>40,00,000</td>
                            <td>17,500</td>
                            <td>57,500</td>
                        </tr>
                        <tr>
                            <td>50,00,000</td>
                            <td>20,000</td>
                            <td>77,500</td>
                        </tr>
                        <tr>
                            <td>1,00,00,000</td>
                            <td>72,500</td>
                            <td>1,50,000</td>
                        </tr>
                        </tbody>
                    </table>
                    <table class="table finzy-datatable table-responsive">
                        <thead style="font-weight: bold">
                        <td>Cumulative Borrowing Milestones(&#8377;)</td>
                        <td>Referral Earning(&#8377;)</td>
                        <td>Total Referral Earnings(&#8377;)</td>
                        </thead>
                        <tbody>
                        <tr>
                            <td>1,00,000</td>
                            <td>500</td>
                            <td>500</td>
                        </tr>
                        <tr>
                            <td>5,00,000</td>
                            <td>2,000</td>
                            <td>2,500</td>
                        </tr>
                        <tr>
                            <td>10,00,000</td>
                            <td>3,000</td>
                            <td>5,500</td>
                        </tr>
                        <tr>
                            <td>20,00,000</td>
                            <td>7,000</td>
                            <td>12,500</td>
                        </tr>
                        <tr>
                            <td>30,00,000</td>
                            <td>10,000</td>
                            <td>22,500</td>
                        </tr>
                        <tr>
                            <td>40,00,000</td>
                            <td>12,500</td>
                            <td>35,000</td>
                        </tr>
                        <tr>
                            <td>50,00,000</td>
                            <td>15,000</td>
                            <td>50,000</td>
                        </tr>
                        <tr>
                            <td>1,00,00,000</td>
                            <td>50,000</td>
                            <td>1,00,000</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <ul>
                    <li>Funded Borrower is defined as a borrower who has applied for a loan at finzy.com and
                        the loan amount has
                        been successfully disbursed
                    </li>
                    <li>Investor is defined as a lender who has created their first portfolio on or after {{raferralDate.dateFrom}}
                        in loans at finzy.com
                    </li>
                    <li>The upper limit for an individual investor is &#8377; 50 lakhs investment across all P2P
                        platforms. The maximum loan amount a borrower can apply for is &#8377; 5 lakh.
                    </li>
                    <li>
                        Referral Plan is limited to only one level of reference.
                        <p>
                            Example - If Investor A refers Investor B and Investor C. And Investor B in turn refers
                            Investor
                            D. Investor A’s incentive will be calculated on direct investment of Investor B and
                            Investor C
                            and not of Investor D. Only Investor B will get such incentive for direct investment of
                            Investor D.
                        </p>
                    </li>
                </ul>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        6. How do I know the status of my referrals?
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">We will send you an email every time you cross a cumulative investment or
                    borrowing milestone. You can also get in touch with us at suport@finzy.com to understand the status
                    of your
                    referrals.</p>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        7. How will I receive my referral earnings?
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">Once a cumulative investment or borrowing milestone is achieved, the referral
                    incentive will be paid out to your registered bank account in the following month referral payment
                    cycle.</p>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        8. I have already registered with finzy how do I get my referral code?
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">Don't worry we have you covered. You should receive an email with your
                    personal
                    referral code. Alternately the code is also available on your personal dashboard in the 'Refer &
                    Earn'
                    section.</p>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        9. I have already referred people to finzy in the past, do I earn referral benefits for them?
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">The current referral program is valid for referrals between the 
                    {{raferralDate.dateFrom}}
                    and {{raferralDate.dateTo}}. <br/>
                    Lender - For all first portfolios created on or after {{raferralDate.dateFrom}} <br/>
                    Borrower - For all loans disbursed on or after {{raferralDate.dateFrom}} <br/>
                    Any referrals before this period will be covered under the

                    previous points based referral program.</p>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        10. The person I referred forgot to enter the code I gave them, how do I ensure that I earn
                        benefits of the referral program?
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">Ideally you should ask your friends to enter the referral code when they
                    apply,
                    however if for some reason they have missed this, you can write to us at support@finzy.com and we
                    will assign
                    your referral code to them from the backend after verifying that they meet the necessary
                    criteria.</p>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        11. I have referred a borrower but they did not get a loan, what can I do?
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">You earn referral benefits only when the person you refer gets their loan
                    disbursed.
                    However,
                    all loans on finzy go through a credit decisioning process. There are chances that some borrowers
                    may not meet
                    the necessary criteria for finzy to give them a loan. This decision lies solely with finzy. In case
                    where the
                    person you referred does not get their loan disbursed, you can always refer more people and stand
                    a chance to earn more!</p>
            </mat-expansion-panel>

        </div>

        <div [class.active]="selectedTab == Tabs.REINVEST" class="tab-pane" id="6b">
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        1. What is Reinvest-Pro?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">
                    Once you invest in loans through one or more investment portfolios on finzy, you begin to receive
                    repayments through the following
                    modes:
                    <br/>
                    1. Regular Monthly EMIs (Which contain both Principal and Interest components)
                    <br/>
                    2. Prepayments (Where the borrower may make a payment in advance to either to repay their loan
                    completely or in parts)
                    <br/>
                </p>

                <p class="faq-acc-content">
                    By default, all these repayments are sent back to your registered bank account. However if you wish
                    to reinvest these returns back
                    into new loans, Reinvest-Pro allows investors on finzy to set preferences that allots and reinvests
                    these repayments into new
                    loans on the platform.
                </p>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        2. How does Reinvest-Pro Work?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">
                    Reinvest-Pro allots and reinvests your EMIs and principal prepayments. Here is how it works:
                    <br/>
                    <br/>
                    <b>Step 1: Select your Reinvest-Pro preferences on the <a href="preferences" target="_blank">investor
                        dashboard</a></b>
                    <br/>
                    <br/>
                    The preferences are flexible, you could choose to reinvest the entire EMI and any prepayments that
                    you receive. You could choose
                    to reinvest just the prepayments and continue getting EMIs back to your registered bank account or
                    vice versa. You may also choose
                    to just reinvest only the Principal or Interest component of the EMIs.

                    <br/>
                    <br/>
                    <b>Step 2: Based on your preferences finzy helps to allot and reinvest the repayments</b>
                    <br/>
                    <br/>

                    When a repayment occurs, based on your preferences finzy will allot and reinvest all or part of the
                    repayments in new loan(s).
                    <br/>
                    <br/>
                    We will find loans for you and send you an email about what loans your funds have been allotted in.
                    All these reinvestments will
                    be
                    part of a new portfolio that the system will create called the "Reinvest Portfolio" which will be
                    available to you on the investor
                    dashboard.
                    <br/>
                    <br/>
                    <b>Step 3: You receive details of what was reinvested</b>
                    <br/>
                    <br/>
                    Every time you receive a repayment, we will send you an email that details what repayment you
                    received and how Reinvest-Pro
                    handled it.
                    <br/><br/>
                    <b>There are some basic rules:</b>
                    <br/>
                    <br/>
                    Loans are allotted and reinvested only in multiples of ₹ 1000, so if your repayments are not a well
                    rounded number, then we send
                    the additional amount to your finzy wallet.
                    <br/>
                    <br/>
                    In addition, RBI guidelines mandate that an individual investor cannot have a principal outstanding
                    of more than ₹ 50 lakhs across
                    P2P platforms. In case your repayments, if reinvested, breach this mark, then we will send the
                    remaining portion back to your
                    registered bank account.
                </p>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        3. What are the advantages of Reinvest-Pro?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">
                    Reinvest-Pro has the following distinct benefits:
                    <br/><br/>
                    1. You do not need to collate returns from finzy and then create a new portfolio. Reinvest-Pro
                    feature helps you reinvest your
                    returns as you receive them.
                    <br/>
                    2. Reinvesting the returns helps you unlock the power of interest compounding that helps you make
                    your returns work for you.
                    <br/>
                    3. It leads to better diversification, as the returns are invested in
                    Multiple loans, thereby diversifying your investments across more loans with granular exposure.
                </p>

            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        4. What if I want my repayments back and do not want to reinvest?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">
                    Some of our investors may wish to continue getting all their repayments back to their registered
                    bank account and not to reinvest
                    the returns. In such case, you can choose your preference to send back the returns to your
                    registered bank accounts (this will be
                    the default preference selected).
                </p>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        5. Are there any charges for Reinvest-Pro feature?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">
                    As a valued Investor at Finzy, you get access to the Reinvest-Pro feature without any charges or
                    fees.
                </p>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        6. How can I select the desired Reinvest-Pro preferences?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">
                    You can select your desired Reinvest-Pro preferences from the <a href="preferences" target="_blank">investor
                    dashboard</a>.
                </p>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        7. Do I need to select the loans in Reinvest-Pro?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">
                    When a repayment occurs, based on your preferences finzy will allot all or part of the repayments in
                    new loan and send you an email about which loan we have allotted the funds.<br/><br/>

                    You can also choose the loan rating categories that you would want Reinvest-Pro to invest in by
                    setting the “finzyPRO+ Master Rating Preference”.<br/><br/>

                    We also send you an email with the details of the new loan(s) found as a part of your Reinvest-Pro
                    portfolio, you can review the loans before re-investing and also you get an option to reverse the
                    investment into the allotted loan.
                </p>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        8. How do I set my loan rating preference for Reinvest-Pro portfolios?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">
                    You can select you preferred loan rating categories in the “finzyPRO+ Master Rating Preference”.
                    Only loans from these categories will be picked while creating your Reinvest-Pro
                    portfolio.<br/><br/>

                    This preference will be applied to all Reinvest-Pro portfolios that are created after you save your
                    customisation.
                </p>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        9. What if I want to receive my EMI for one particular or for a specific period?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">
                    Our Reinvest-Pro preferences are flexible, at any point in time when you want to opt out of
                    reinvesting your returns & take back
                    all your repayments, you can just choose your preference from <a href="preferences" target="_blank">investor
                    dashboard</a> to send
                    back all your money to your registered bank account.
                </p>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        10. What will be my rate of return on reinvested loans?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">
                    Each loan allotted and reinvested will carry its own Finzy rating and ROI. Existing ROI of your
                    portfolio or the loan being
                    prepaid
                    would not have any bearing on the ROI of allotted and reinvested loan.
                </p>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        11. What will be tenure for my Reinvest-Pro portfolio?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">
                    Each time you reinvest in a new loan, that loan would run for its tenure (6, 12, 24 or 36 months,
                    depending on the loan) from the date of disbursement of reinvested loan.
                </p>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        12. Why are my returns not completely reinvested?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">
                    Loans are allotted and reinvested only in multiples of ₹1000, so if your repayments are not a well
                    rounded number, then we send
                    the additional amount to your finzy wallet. In addition, RBI guidelines mandate that an individual
                    investor cannot have a
                    principal outstanding of more than ₹50 lakhs across P2P platforms. In case your repayments, if
                    reinvested breach this mark, then
                    we will send the remaining portion back to your registered bank account.
                </p>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        13. Does the fund remaining uninvested in wallet earn any interest?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">
                    Please note that neither you nor finzy earns any interest for overnight balance maintained in escrow
                    account. You have an option
                    to request for transfer of any funds in the wallet to your registered bank account.
                </p>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        14. How do I know what was invested through Reinvest-Pro and when?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">
                    Every time you receive a repayment for which you have chosen the option to reinvest, we will send
                    you an email that details what
                    repayment you received and how Reinvest-Pro handled it.

                    <br/>
                    <br/>

                    We also send you an email with the details of the loan that that were found as a part of your
                    Reinvest-Pro portfolio. Our
                    Investment summary mail and the Returns on investment mail also will have the details about the the
                    Reinvest-Pro portfolio.
                </p>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        15. How do I monitor the performance of my Reinvest-Pro portfolio?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">
                    We provide an overview of your Reinvest-Pro portfolio on the <a href="preferences" target="_blank">investor
                    dashboard</a>, where
                    you will find detailed information about loans invested, status of each loan, borrower details & ROI
                    earned from reinvesting your
                    repayments.
                </p>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        16. What happens to reinvestment preferences once I reach statutory limit of ₹50 lakhs?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">
                    We will allot and reinvest only the value such that we restrict your exposure on Finzy to the
                    statutory limit of ₹50 lakhs.
                    Excess money will be sent back to your registered bank account.
                </p>
            </mat-expansion-panel>
        </div>

        <div [class.active]="selectedTab == Tabs.FINZY_BOLT" class="tab-pane" id="7b">
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        1. What is finzyBolt?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">
                    finzyBolt is a convenient feature allowing you to allowing you to allocate your wallet funds into the loan(s) without you visiting the platform. 
                    Funds can be credited into the wallet from 
                    A. money that you transfer from your bank account, 
                    B. money sent to wallet during reinvestment or, 
                    C. money sent to wallet during a loan closure.
                </p>
                <p class="faq-acc-content">
                    finzyBolt uses our proprietary finzyPRO+ logic to <strong>allocate loans without you visiting our platform</strong>. 
                    There is money in the wallet in excess of ₹1000.
                </p>
                <p class="faq-acc-content">
                    Please note, by switching on finzyBolt, the capability to create portfolios yourself will not be available.
                </p>
            </mat-expansion-panel>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        2. How does finzyBolt work?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content font-weight-bold"> finzyBolt allocate your wallet funds into the loan(s) without you visiting the platform. Here is how it works:</p>
                <p class="faq-acc-content">
                    <br/>
                    <strong>
                        Step 1: Choose to switch on finzyBolt while completing your registration or set it up later on the
                        <a href="/preferences" target="_blank"> investor dashboard</a>.
                    </strong>
                </p>
                <p class="faq-acc-content">
                    You could choose to allocate funds credited to your wallet by switching on finzyBolt investment preference while submitting your registration form. 
                    You can also switch on finzyBolt from the investor dashboard.
                </p>
                <p class="faq-acc-content">
                    <br/>
                    <strong>
                        Step 2: Based on your finzyBolt preference finzy will allot the funds available in your wallet into loan(s).
                    </strong>
                    <br/>
                </p>
                <p class="faq-acc-content">
                    When a wallet credit happens, finzy will allot and invest all or part of the funds available in the wallet into new loan(s) in multiples of ₹1000. 
                    finzyBolt uses our proprietary finzyPRO+ algorithm. It takes into account the following when selecting loans:
                    <br/><br/>
                    A. Ensures that the loan is not very high-risk - So the algorithm will not pick any loans that belong to the C Category.
                    <br/>
                    B. Ensures diversification – It will invest only 20% of the loan amount or 10% of your portfolio amount, whichever is lower.
                    <br/>
                    C. Ensures that you do not invest in the same loan more than once.
                    <br/>
                    D. Ensures that the total investment in a single loan is not more than ₹ 20,000. 
                </p>
                <br/>
                <p class="faq-acc-content">
                    All these investments will be part of a new portfolio that the system will create called the "finzyBolt Portfolio". 
                    You can view this portfolio on your investor dashboard.
                </p>
                <p class="faq-acc-content">
                    For finzyBolt investments, the minimum amount that is required in your wallet is ₹1000. 
                    If the wallet balance is anything lesser than ₹1000, then the funds won't be invested into loan(s) and will remain in the wallet.
                </p>
                <p class="faq-acc-content"><br/>
                    <b>Step 3: You receive details of what was invested</b>
                </p>
                <p class="faq-acc-content">
                    You will receive an email confirming the allocation along with the details of the loan and the borrower. 
                    You will have a choice to remove the allocation from this specific loan by sending an email to finzy or by simply reversing it from your dashboard within a stipulated time, we will remove the allocation and find a replacement loan for you. 
                    If you accept the allocated loan, you are all set and need not take any action.
                </p>
                <p class="faq-acc-content">
                    <br/>
                    <b>There are some basic rules:</b> <br/>
                </p>
                <p class="faq-acc-content">
                    Loans are allotted and invested only in multiples of ₹1000, so any balance amount that is not a rounded number remains in the wallet.
                </p>
                <p class="faq-acc-content">
                    In addition, RBI guidelines mandate that an individual investor cannot have a principal outstanding of more than ₹ 50 lakhs across P2P platforms. 
                    In case your principal outstanding breaches this mark, from then on any money transferred to wallet from your bank account will not be invested into loan(s).
                </p>
            </mat-expansion-panel>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>

                        3. What are the advantages of finzyBolt?
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">
                    finzyBolt has the following distinct benefits:
                    <br/>
                </p>
                <ul>
                    <li>No need for any manual intervention on transfer of funds to finzy wallet.</li>
                    <li>No need to keep track of your idle funds in the wallet. Funds accumulated in finzy wallet adding to ₹1000 or more will trigger new investment.</li>
                    <li>Offer more granular distribution by determining a dynamic investment amount which varies based on portfolio amount and finzy Rating of the loan.</li>
                </ul>
            </mat-expansion-panel>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        4. How do I set my finzyBolt preference?
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content"> You can switch on finzyBolt while completing your investment application.
                    You can
                    also choose to switch it on later on your <a href="/preferences" target="_blank">investor
                        dashboard</a>.
                </p>
            </mat-expansion-panel>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        5. Can I create a portfolio from dashboard when finzyBolt preference is turned on?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content"> You will not be able to create any portfolios from the investor dashboard
                    when you
                    have opted for finzyBolt. If you wish to transfer funds and create portfolios yourself, you can
                    switch off
                    finzyBolt anytime from your preferences <a href="/preferences"
                                                               target="_blank">here</a> and then
                    transfer funds.
                </p>
            </mat-expansion-panel>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>

                        6. Are there any charges for finzyBolt feature?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">
                    As a valued Investor at Finzy, you get access to the finzyBolt feature without any charges or fees.
                </p>
            </mat-expansion-panel>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        7. Can I choose the loans that I want to invest in finzyBolt?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">
                    finzyBolt uses our proprietary finzyPRO+ logic which is designed to select
                    best loans in your portfolio. You can also choose the loan rating categories that you would want
                    finzyBolt to invest in by setting the “finzyPRO+ Master Rating Preference”. <br/><br/>
                    In case you want to choose loans yourself, you can use finzy Manual Invest to create your own
                    portfolio using your own assessment and judgement. This capability will be available only when
                    the finzyBolt preference is turned off.
                </p>
            </mat-expansion-panel>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        8. How do I set my loan rating preference for finzyBolt portfolios?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">
                    You can select you preferred loan rating categories in the “finzyPRO+ Master Rating Preference”.
                    Only loans from these categories will be picked while creating your finzyBolt portfolio.
                    <br/><br/>
                    This preference will be applied to all finzyBolt portfolios that are created after you save your
                    customisation.
                </p>
            </mat-expansion-panel>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>

                        9. What is the minimum and maximum amount that I can invest using finzyBolt?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">
                    For your first investment, you will need a minimum of ₹ 50,000 in your finzy wallet for finzyBolt to
                    invest in
                    loans. After this initial investment, you will need a minimum wallet balance of ₹ 1,000 to use
                    finzyBolt.
                    There is no upper limit for investments, aside from the RBI imposed ₹ 50 lakhs cap for investment
                    across all
                    P2P platforms.
                </p>

            </mat-expansion-panel>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>

                        10. How do I know that my funds have been invested?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">
                    Every time your wallet is credited and finzyBolt invests into loan(s), we will send you an email
                    with details
                    of your wallet funds that were available and how finzyBolt handled it. You will have a 12 hour
                    window from the
                    time of the email to request for a replacement of the loan allotted with a different loan. If we do
                    not hear
                    from you within the 12 hour window, your investment will be confirmed in the allotted loan.
                </p>

            </mat-expansion-panel>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>

                        11. How is finzyBolt different from Reinvest-Pro?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">
                    finzyBolt invests all the funds that come to wallet including transfer from your bank account and
                    credits from closure of an loan. While Reinvest-Pro invests only the EMI interest, EMI Principal and
                    Prepayments from your already invested portfolios. finzyBolt and Reinvest-Pro preferences are
                    independent of each other. You can choose to switch on one or more of the preferences at any given
                    time.
                </p>
            </mat-expansion-panel>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>

                        12. Who is finzyBolt meant for?
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p class="faq-acc-content">
                    finzyBolt is best suited for investors who have already created finzyPRO+ or finzy Manual portfolios
                    and understand the kind of loan profiles available at finzy platform. finzyBolt works well for
                    investors who want to make their money work without active intervention.
                </p>
            </mat-expansion-panel>

        </div>


        <div [class.active]="selectedTab == Tabs.FINZY_FLEX" class="tab-pane" id="8b">								
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>1. What is finzyFLEX?</mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">																									
                    finzyFLEX is an unique investment opportunity offering a new level of flexibility for investors. 
                    Here you can choose your return rate and receive periodic cashflows at desired frequency. 
                    You also get an opportunity to withdraw your investment post the minimum holding  period (MHP).
                </p>
            </mat-expansion-panel>																									
                                                                                                        
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>2. What is minimum of investment required for finzyFLEX?</mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">																									
                    You can start investing with a minimum of INR 50,000. For subsequent  investments the minimum amount required will be INR 10,000.
                </p>
            </mat-expansion-panel>																									
                                                                                                        
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>3. Are there any charges for finzyFLEX?</mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">																									
                    There are no charges or fees at the time of registration and for investing in finzyFLEX. 
                    finzy will earn differential in interest between the interest rate paid by the borrower and Investor interest rate. 
                    finzy will not earn any income, if such interest differential is zero or is negative.
                </p>
            </mat-expansion-panel>																									
                                                                                                        
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>4. What are the advantages of finzyFLEX?</mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">																									
                    finzy Flex offers following distinct advantages:
                </p>
                <ul class="dashed">
                    <li>Flexible investment options</li>
                    <li>Steady and Customized Cashflows</li>
                    <li>Withdraw Investments post minimum holding period (MHP)</li>
                </ul>
            </mat-expansion-panel>																									
                                                                                                        
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>5. How does finzyFLEX work?</mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">																									
                    In finzyFLEX you start by allocating funds across investment options, then loans are allocated to your investment, 
                    you can review the allocated loans and reverse the loan allocation within a given time period. 
                    You earn daily interest and that can be withdrawn in form of periodic nCash payout. You may also withdraw your 
                    investment and returns after minimum holding period (MHP) by assignment of your outstanding loans to new investors. 
                    Repayments in excess of your withdrawals are reinvested.
                </p>
            </mat-expansion-panel> 																									
                                                                                                        
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>6. Can I select loans in finzyFLEX?</mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">																									
                    finzyFLEX is designed to allocate your funds to investment options basis your choice and preferences set by you. 
                    Funds are further allocated to loans with an option for you to review and reverse such loan allocation within a given time period. 
                    Such reversal can be done from your dashboard. Reversal request will not be allowed post expiry of this time period.
                </p>
            </mat-expansion-panel>																									
                                                                                                        
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>7. What returns can I expect in finzyFLEX?</mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">																									
                    finzyFLEX offers interest rate ranging from 9% per annum to 12% per annum. This return is indicative, 
                    subject to credit risk and performance of underlying loans in your investment portfolio. Your realised returns may be 
                    lower than the indicated interest rate for different investment option.
                </p>
            </mat-expansion-panel>																									
                                                                                                        
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>8. Are my returns guaranteed in finzyFLEX?</mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">																									
                    Interest rate mentioned are indicative and finzy does not guarantee any interest rate or return of principal. 
                    Investments made herein are subject to credit risk and loss might arise out of non performing underlying loans 
                    to which investor has an exposure and investors solely carry risks of any loss arising out of such loans.
                </p>
            </mat-expansion-panel>																									
                                                                                                        
                                                                                                        
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>9. How is interest calculated?</mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">																									
                    Investor Interest Rate referred herein is simple interest rate and is indicative and will be calculated on a daily basis 
                    and on actual/365 day count convention basis. Such interest amount will be paid either on periodic basis in form of nCash or upon withdrawal.
                </p>
            </mat-expansion-panel> 																									
                                                                                                        
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>10. How do I transfer funds to my finzy Wallet?</mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">																									
                    Funds can be transferred from your dashboard using Net banking/UPI/Debit Card to your finzy wallet  or alternatively, 
                    you can transfer to your finzy virtual account number mentioned on your dashboard from your bank account. Your virtual 
                    account number is available in "Add Funds" section.
                </p>
            </mat-expansion-panel>																									
                                                                                                        
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>11. What is the minimum and maximum amount that I can invest using finzyFLEX?</mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">																									
                    For your first investment, you will need a minimum of INR 50,000 in your finzy wallet to invest. For subsequent  investment, 
                    you will need a minimum wallet balance of INR 10,000. As per RBI regulations, maximum amount of investment is limited to INR 50,00,000 
                    across all P2P platforms. Investments above INR 10,00,000 would require a networth certificate from your CA. finzy team can support you 
                    in getting such CA certificate at no additional cost.
                </p>
            </mat-expansion-panel>																									
                                                                                                        
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>12. When does my money start earning interest?</mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">																									
                    Your investments start earning interest from day of you successfully creating your investment portfolio, provided the funds remain invested overnight.
                </p>
            </mat-expansion-panel> 																									
                                                                                                        
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>13. What is MHP?</mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">																									
                    Minimum Holding Period is the lock in period in months when the fund withdrawal requests cannot be placed by investors. Minimum Holding Period is not 
                    maturity date, your funds continue to remain invested till you place withdrawal request from your dashboard.
                </p>
            </mat-expansion-panel>																									
                                                                                                        
            <mat-expansion-panel [expanded]="preferenceType == 'swift'" id="swift">
                <mat-expansion-panel-header>
                    <mat-panel-title>14. What is SWIFT?</mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">																									
                    SWIFT is a convenient investment option allowing you to <strong>allocate</strong> your wallet funds into the loan(s) without you visiting the platform. 
                    SWIFT uses our proprietary logic to allocate loans to your preferred investment option every time there is money in the wallet in excess of INR 1,000. 
                    Please note, by switching on SWIFT, the capability to invest yourself will not be available on the dashboard. You need to switch off SWIFT, if you want to invest yourself from dashboard.
                </p>
            </mat-expansion-panel>																										
                                                                                                        
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>15. How can I set my SWIFT preference?</mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">																									
                    You can switch on your SWIFT preference  while registering with finzy or anytime post that from your dashboard. You may edit your set preference anytime you want. 
                    Switching on SWIFT, will lead to investment of any amount in excess of INR 1,000 from your finzy wallet balance.
                </p>
            </mat-expansion-panel>																									
                                                                                                        
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>16. Can I create a portfolio from dashboard when SWIFT preference is turned on?</mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">																									
                    You will not be able to invest from your dashboard when you have opted for SWIFT. If you wish to invest yourself, you must switch off the SWIFT preference 
                    and then transfer funds to your finzy wallet.
                </p>
            </mat-expansion-panel>																									
                                                                                                        
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>17. Are there any charges for SWIFT feature?</mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">																									
                    As a valued investor at finzy, you get access to the SWIFT feature without any charges or fees.
                </p>
            </mat-expansion-panel>																									
                                                                                                        
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>18. Can I select investment option while setting up the SWIFT preference?</mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">																									
                    You  can select the allocation percentage for different investment option while setting up the SWIFT preference. Your funds will be further allocated to loans 
                    with an option for you to review and reverse such loan allocation within a given time period. Such reversal can be done from your dashboard. Reversal request 
                    will not be allowed post expiry of this time period.
                </p>
            </mat-expansion-panel>																									
                                                                                                        
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>19. What will happen to my finzyBolt preference, if SWIFT is turned on?</mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">																									
                    finzyBolt will be automatically switched off, if SWIFT option is enabled and vice versa. At any point in time either finzyBolt or SWIFT preference can be active.
                </p>
            </mat-expansion-panel>																									
                                                                                                        
            <mat-expansion-panel [expanded]="preferenceType == 'nCash'" id="nCash">
                <mat-expansion-panel-header>
                    <mat-panel-title>20. What is nCash?</mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">																									
                    nCash is a feature which provides you an option to withdraw a fixed or a customized amount periodically from your finzyFLEX investments. Periodic withdrawals 
                    will be permitted upto a maximum amount which may vary as per the investment option opted by you. Such maximum nCash amount is  determined and set by finzy and 
                    cannot be modified.
                </p>
            </mat-expansion-panel>																									
                                                                                                        
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>21. How can I avail nCash?</mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">																									
                    You can set your nCash preferences  while registering with finzy or anytime post that from your dashboard. Your nCash payout will be paid out effective the 
                    following cashflow period after the preference setup month.
                </p>
            </mat-expansion-panel>																									
                                                                                                        
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>22. Is nCash payout same as interest earned from my investment?</mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">																									
                    nCash payout amount may be more than, less than or equal to your interest earned. Your investment outstanding will progressively increase if you do not withdraw 
                    nCash or your nCash payout is less than your interest earned. However, if your nCash payout is more than the interest earned then over a period of time your 
                    investment outstanding will progressively decrease and might go down to zero.
                </p>
            </mat-expansion-panel>																									
                                                                                                        
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>23. What are the various options for setting up my nCash preference?</mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">																									
                    You have complete flexibility to set up your nCash preference with below mentioned options:
                </p>
                <ol type="a">
                    <li>You can chose the nCash amount</li>
                    <li>You can chose the nCash periodicity</li>
                    <li>You can chose the nCash date</li>
                </ol>
            </mat-expansion-panel>																									
                                                                                                        
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>24. What are the various options for nCash withdrawal amount?</mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">																									
                    You may setup the nCash withdrawal amount as any of the below option:
                </p>
                <ol>
                    <li>Interest Only - Receive actual interest earned from preference setup date to the payout date</li>
                    <li>
                        Custom amount - Receive customised nCash amount with minimum of INR 100 and maximum being capped at system defined maximum nCash 
                        amount based on your investment amount
                    </li>
                    <li>Max nCash amount - Receive system defined maximum nCash amount based on your investment amount</li>
                </ol>
                <p class="faq-acc-content">
                    Excessive withdrawal of periodic nCash over interest earned will  progressively decrease  your investment outstanding amount and the same might go down to zero.
                </p>
            </mat-expansion-panel>																									
                                                                                                        
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>25. What are the various options for nCash periodicity?</mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">																									
                    You may setup any of the below frequency options for nCash withdrawal:
                </p>
                <ol class="faq-acc-content">
                    <li>Monthly</li>
                    <li>Quarterly</li>
                    <li>Semi-Annually</li>
                    <li>Annually</li>
                </ol>
                <p class="faq-acc-content">
                    When setting up monthly, quarterly, semi-annually or annually nCash periodicity the first payout would happen in the next, 3rd, 6th or 12th month respectively 
                    from the preference setup month.
                </p>
            </mat-expansion-panel>																									
                                                                                                        
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>26. What are the various options for nCash date?</mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">																									
                    You may setup nCash withdrawal to be credited to your bank account on 10th, 20th or 30th day of the month. If payout date happens to be a banking holiday, 
                    payouts will be made on the next bank working day. For working day and banking days, we shall follow RBI Holiday calendar for Mumbai.
                </p>
            </mat-expansion-panel>																									
                                                                                                        
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>27. Can i change my nCash preference?</mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">																									
                    Yes, you can change your preferences for nCash from your dashboard. Changes to nCash preferences may be effective from the following cashflow period. 
                    Any such change before the scheduled nCash payout would override any existing scheduled nCash payout. Change in date can come into effect from current month, 
                    only if new date is a later date. For example, on 7th one cannot change 20th nCash  date to 10th (would come into effect only from next month) however a 10th 
                    can be changed to 20th (would come into effect from current month)
                </p>
            </mat-expansion-panel>																									
                                                                                                        
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>28. Are there any charges for nCash feature?</mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">																									
                    As a valued investor at finzy, you get access to the nCash feature without any charges or fees.
                </p>
            </mat-expansion-panel>																									
                                                                                                        
            <mat-expansion-panel [expanded]="liquidityCase == 'liquidity'" id="liquidity">
                <mat-expansion-panel-header>
                    <mat-panel-title>29. Can i withdraw my investments in finzyFLEX?</mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">																									
                    Withdrawal of investments is offered on a best effort basis post minimum holding  period (MHP). Withdrawal Amount may be full principal outstanding 
                    or part amount. Such proceeds will be paid to you by assignment of your outstanding loans to new investors or from your accumulated returns.
                </p>
            </mat-expansion-panel>																									
                                                                                                        
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>30. How can I withdraw my investment?</mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">																									
                    Withdrawal request can be made from your dashboard only after any of your investment has remained invested for more than minimum holding  period (MHP)
                </p>
            </mat-expansion-panel>																									
                                                                                                        
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>31. When will i receive my withdrawal amount after making the withdrawal request?</mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">																									
                    Withdrawal requests are funded by assignment of your outstanding loans to new investors, hence it is subject to availability of funds from new investors. 
                    We will try to transfer the funds to your registered bank account at earliest possible time, subject to our best efforts. Under normal circumstances, 
                    you should expect funds in your bank account within 7 days from the withdrawal request.
                </p>
            </mat-expansion-panel> 																									
                                                                                                        
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>32. Is there a Maturity Date for finzyFLEX investments?</mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">																									
                    finzyFLEX investments are open ended investments without any maturity date. You may withdraw your investment in part or in full 
                    post the minimum holding  period (MHP).
                </p>
            </mat-expansion-panel>																									
                                                                                                        
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>33. Can my return be lower than the indicated interest rate?</mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">																									
                    In the event your investment suffer credit losses the same would be informed to you through the investor return schedule in 
                    Reports tab and accordingly your effective return might reduce below the indicated interest rate. In such an event, finzy will 
                    not be making any fees from your investments.
                </p>
            </mat-expansion-panel> 																									
                                                                                                        
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>34. Is there any feature of setting up SIP for finzyFLEX?</mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">																									
                    We will soon launch the SIP feature whereby you would be able to setup and edit your SIPs from your dashboard. In the meantime, 
                    you might set up a periodic investment option by switching on SWIFT preference and setting up standing instruction in your bank account 
                    to transfer funds to your finzy virtual account number on desired SIP periodicity. Your virtual account number is available in "Add Funds" section.
                </p>
            </mat-expansion-panel>																									
                                                                                                        
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>35. Can i switch my finzyPRO investments to finzyFLEX?</mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">																									
                    Currently we are not offering any switch of finzyPRO investments to finzyFLEX.
                </p>
            </mat-expansion-panel>																									
                                                                                                        
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>36. Can i reinvest repayments from my finzyPRO investments to finzyFLEX?</mat-panel-title>
                </mat-expansion-panel-header>
                <p class="faq-acc-content">																									
                    Yes, you can reinvest your repayments from finzy PRO to finzy FLEX.This can be enabled form your finzy PRO dashboard by choosing the respective preference.
                </p>
            </mat-expansion-panel>																									
                                                                                        
        </div>
    </div>
</div>

<app-footer></app-footer>
